<template>
<div>
  <progress-loader customClass="pull-right" customStyle="width:100px; margin-top: -45px" ref="progress"></progress-loader>
  <div style="height:320px; max-height:735px; overflow-y:auto; overflow-x:hidden">
    <ul class="icons-list visitor">
      <li style="height: 20px;"><small><em>Last 30 log of visitors</em></small></li>
      <li v-for="visitor in visitorStatusLog" v-bind:key="visitor.name" v-if="visitorStatusLog.length > 0">
        <i :class="setVisitorStatusColor(visitor.visitorStatus)" ></i>
        <div class="desc">
          <div class="title font-weight-bold">{{ visitor.visitor.name }}</div>
          <small><b>{{visitor.visitorStatus}}</b> at {{visitor.createdAt}}</small>
        </div>
        <div class="actions">
          <b-button :href="'#/visitor/' + visitor.visitor.uuid + '?redirect=%2Fdashboard'" variant="link" class="text-muted"><i class="icon-list"></i></b-button>
        </div>
      </li>
      <li class="text-center" style="padding:100px 0px" v-if="visitorStatusLog.length == 0">
        <h5 class="text-muted">Can't load data for a while</h5>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import progressLoader from '@/views/components/progressLoader'

export default {
  name: 'visitorLog',
  components: {
    progressLoader
  },
  data () {
    return {
      apiUrlGetVisitorStatusLog: window.AppConfig.apiUrl + 'visitor-status-log?limit=30',
      visitorStatusLog: []
    }
  },
  mounted () {
    var self = this
    setTimeout(function () {
      try {
        self.getList()
      } catch (err) {
        self.getList()
      }
      self.doAutoRefresh()
    }, Math.floor(Math.random() * 1200) + 1000)
  },
  beforeDestroy () {
    clearInterval(this.refVisitorLog)
  },
  methods: {
    setVisitorStatusColor (val) {
      switch (val) {
        case 'Registered':
          return 'fa fa-user-plus bg-primary btn-pill'
        case 'Check In':
          return 'icon-login bg-success btn-pill'
        case 'Check Out':
          return 'icon-logout bg-dark text-white btn-pill'
        default:
          return 'icon-ghost bg-secondary btn-pill'
      }
    },
    getList () {
      this.$refs.progress.activateProgressBar()
      axios.get(this.apiUrlGetVisitorStatusLog)
        .then(response => {
          if (response === undefined) return false
          this.$refs.progress.deactivateProgressBar()
          if (response !== undefined) {
            this.visitorStatusLog = response.data._embedded.visitorStatusLog
            for (let i = 0; i < this.visitorStatusLog.length; i++) {
              this.visitorStatusLog[i]['createdAt'] = moment(this.visitorStatusLog[i]['createdAt']).fromNow()
            }
          } else {
            this.visitorStatusLog = []
          }
        })
        .catch(error => {
          this.visitorStatusLog = []
          this.$refs.progress.deactivateProgressBar()
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },

    doAutoRefresh () {
      this.refVisitorLog = setInterval(() => {
        this.getList()
      }, window.AppConfig.IntervalRefreshDataDashboard)
    }
  }

}
</script>


<style>
.desc, .value {
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/visitorLog.vue